import styled from 'styled-components';
import { Progress as AntProgress } from 'antd';

export const ButtonContainer = styled.div`
  position: relative;
  display: inline-flex;
  justify-content: flex-start;
  overflow: hidden;
  border-radius: 8px;

  & .ant-btn-loading-icon .anticon {
    padding-right: 0 !important;
  }

  & .ant-btn-loading-icon {
    padding-right: 8px;
  }
`;

export const Progress = styled(AntProgress)`
  position: absolute;
  left: 1px;
  bottom: 1px;
  height: 3px;
  font-size: 3px !important;
  line-height: 1;
  width: calc(100% - 2px);
  pointer-events: none;

  & .ant-progress-inner {
    border-radius: 1px;
  }

  & .ant-progress-bg {
    height: 3px !important;
  }
`;
